@if(isVisible() && activeToast()) {
  <div class="toast-wrapper">
    <ion-card class="cheers-card" (click)="confirmToast(activeToast()!)">
      <ion-item lines="none" style="--background: transparent;">
        <ion-button slot="start" fill="clear" color="medium" (click)="undoToast(activeToast()!, $event)">
          <ion-icon name="arrow-undo-outline" slot="start"></ion-icon>
          Undo
        </ion-button>
        <ion-label>
          <h2 style="font-weight: 600;">{{ activeToast()?.message }}</h2>
        </ion-label>
        <ion-button (click)="confirmToast(activeToast()!)" slot="end" fill="clear" color="medium">
          <ion-icon name="close-outline"></ion-icon>
        </ion-button>
      </ion-item>

      <div class="progress-bar">
        <div class="progress-fill"></div>
      </div>
    </ion-card>
  </div>
}
